/**
 * React Query hook for the Cost-Benefit Analysis mutation.
 *
 * Uses useMutation (not useQuery) because CBA is a POST request that
 * performs a computation on demand — it is not a cacheable GET resource.
 */

import { useMutation } from '@tanstack/react-query';
import { cbaAPI } from '../api/cba';

/**
 * Trigger a CBA calculation.
 *
 * Usage:
 *   const mutation = useCalculateCBA();
 *   const result = await mutation.mutateAsync(requestBody);
 *
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
export const useCalculateCBA = () => {
  return useMutation({
    mutationFn: (params) => cbaAPI.calculate(params),
  });
};
